import { defineCustomElement } from 'vue'
import posthog from 'posthog-js'
import styles from './style.css?inline'
import Hotspot from './components/hotspot.vue'

posthog.init(
  'phc_FLZSbxR5DJhTdtONfiQtqf8SEjWeaMtnaFwIoyWXPDJ',
  {
    api_host: 'https://us.i.posthog.com',
    ui_host: 'https://us-assets.i.posthog.com',
  },
)

// @ts-expect-error vendor
const MyHotspot = defineCustomElement({ ...Hotspot, styles: [styles] })

export function registerWebComponents() {
  if (typeof window === 'undefined')
    return
  customElements.define('hotspot-standard', MyHotspot)
}
